/* BareLow — Bearefoot-style interactions (core). No dependencies. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const BF = window.BF = window.BF || {};
  const R = (window.Wendle && window.Wendle.routes) || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };

  BF.money = (cents) => {
    const fmt = BF.moneyFormat || '£{{amount}}';
    const v = (cents || 0) / 100;
    const d = (n, dec, t, s) => { const p = n.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(s); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => k === 'amount_no_decimals' ? d(v, 0, ',', '.') : k === 'amount_with_comma_separator' ? d(v, 2, '.', ',') : k === 'amount_no_decimals_with_comma_separator' ? d(v, 0, '.', ',') : d(v, 2, ',', '.'));
  };
  let tt;
  BF.toast = (msg) => {
    let el = $('#BfToast');
    if (!el) { el = document.createElement('div'); el.id = 'BfToast'; el.className = 'bf-toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = msg; el.hidden = false; clearTimeout(tt); tt = setTimeout(() => { el.hidden = true; }, 3000);
  };

  /* Header: mega panels — calm hover-intent */
  const dim = $('[data-bf-dim]');
  let openLi = null, tOpen, tClose;
  const shut = (li, instant) => { const p = $('.bf-panel', li); if (instant && p) { p.classList.add('bf-noanim'); requestAnimationFrame(() => requestAnimationFrame(() => p.classList.remove('bf-noanim'))); } li.classList.remove('is-open'); const b = $('[data-bf-nav-btn]', li); if (b) b.setAttribute('aria-expanded', 'false'); };
  const closePanels = () => { clearTimeout(tOpen); clearTimeout(tClose); $$('.bf-nav__item.is-open').forEach((li) => shut(li, false)); openLi = null; if (dim) dim.classList.remove('is-on'); };
  $$('.bf-nav__item.has-panel').forEach((li) => {
    const btn = $('[data-bf-nav-btn]', li), panel = $('.bf-panel', li);
    const open = () => {
      clearTimeout(tOpen); clearTimeout(tClose);
      if (openLi === li) return;
      const switching = !!openLi;
      $$('.bf-nav__item.is-open').forEach((x) => shut(x, true));
      if (switching && panel) panel.classList.add('bf-noanim');
      li.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); openLi = li;
      if (dim) dim.classList.add('is-on');
      if (switching && panel) requestAnimationFrame(() => requestAnimationFrame(() => panel.classList.remove('bf-noanim')));
    };
    btn.addEventListener('click', (e) => { e.preventDefault(); openLi === li ? closePanels() : open(); });
    if (matchMedia('(hover:hover)').matches) {
      li.addEventListener('mouseenter', () => { clearTimeout(tClose); clearTimeout(tOpen); if (openLi && openLi !== li) open(); else if (!openLi) tOpen = setTimeout(open, 180); });
      li.addEventListener('mouseleave', () => { clearTimeout(tOpen); if (openLi === li) tClose = setTimeout(closePanels, 300); });
    }
  });
  $$('.bf-nav__item:not(.has-panel)').forEach((li) => li.addEventListener('mouseenter', () => { clearTimeout(tOpen); if (openLi) { clearTimeout(tClose); tClose = setTimeout(closePanels, 120); } }));
  if (dim) dim.addEventListener('click', closePanels);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closePanels(); closeMenu(); BF.closeCart(); } });

  /* Localization */
  $$('[data-bf-loc]').forEach((w) => {
    const b = $('[data-bf-loc-btn]', w), l = $('[data-bf-loc-list]', w), f = $('form', w);
    if (b && l) b.addEventListener('click', () => { l.hidden = !l.hidden; b.setAttribute('aria-expanded', String(!l.hidden)); });
    $$('[data-country]', w).forEach((c) => c.addEventListener('click', () => { $('[name=country_code]', f).value = c.dataset.country; f.submit(); }));
    document.addEventListener('click', (e) => { if (l && !w.contains(e.target)) l.hidden = true; });
  });
  $$('[data-bf-loc-select]').forEach((s) => s.addEventListener('change', () => s.form.submit()));

  /* Mobile menu */
  const mm = $('#BfMenu');
  function closeMenu() { if (mm) { mm.classList.remove('is-open'); document.documentElement.style.overflow = ''; } }
  $$('[data-bf-menu-open]').forEach((b) => b.addEventListener('click', () => { mm.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }));
  $$('[data-bf-menu-close]').forEach((b) => b.addEventListener('click', closeMenu));

  /* Carousels */
  BF.initCarousels = (root = document) => $$('[data-bf-car]', root).forEach((car) => {
    if (car.dataset.ready) return; car.dataset.ready = 1;
    const tr = $('[data-bf-track]', car), dots = $('[data-bf-dots]', car);
    if (!tr) return;
    const pages = () => Math.max(1, Math.round(tr.scrollWidth / Math.max(1, tr.clientWidth)));
    const cur = () => { const max = tr.scrollWidth - tr.clientWidth; return max <= 0 ? 0 : Math.round(tr.scrollLeft / max * (pages() - 1)); };
    const go = (i) => tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' });
    const draw = () => {
      if (!dots) return; const n = pages();
      if (dots.children.length !== n) { dots.innerHTML = ''; for (let i = 0; i < n; i++) { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to slide ' + (i + 1)); b.addEventListener('click', () => go(i)); dots.appendChild(b); } }
      dots.hidden = n < 2; const c = cur(); [...dots.children].forEach((b, i) => b.setAttribute('aria-current', String(i === c)));
    };
    tr.addEventListener('scroll', () => requestAnimationFrame(draw), { passive: true });
    window.addEventListener('resize', draw);
    const p = $('[data-bf-prev]', car), n = $('[data-bf-next]', car);
    if (p) p.addEventListener('click', () => tr.scrollBy({ left: -tr.clientWidth, behavior: 'smooth' }));
    if (n) n.addEventListener('click', () => tr.scrollBy({ left: tr.clientWidth, behavior: 'smooth' }));
    draw();
  });

  /* Tabs */
  $$('[data-bf-tabs]').forEach((w) => {
    const btns = $$('[role=tab]', w);
    btns.forEach((b) => b.addEventListener('click', () => {
      btns.forEach((x) => { x.setAttribute('aria-selected', String(x === b)); const p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = x !== b; });
      const p = document.getElementById(b.getAttribute('aria-controls'));
      if (p) { const c = $('[data-bf-car]', p); if (c) delete c.dataset.ready; BF.initCarousels(p); }
    }));
  });

  /* Product cards */
  BF.initCards = (root = document) => $$('.bf-card', root).forEach((c) => {
    if (c.dataset.ready) return; c.dataset.ready = 1;
    const s = $('.bf-card__slides', c), d = $$('.bf-card__dots span', c);
    if (s && d.length) s.addEventListener('scroll', () => { const i = Math.round(s.scrollLeft / s.clientWidth); d.forEach((x, n) => x.classList.toggle('is-on', n === i)); }, { passive: true });
    $$('.bf-sw button', c).forEach((b) => b.addEventListener('click', () => {
      $$('.bf-sw button', c).forEach((x) => x.classList.toggle('is-on', x === b));
      const img = $('.bf-card__slide img', c);
      if (img && b.dataset.img) { img.removeAttribute('srcset'); img.src = b.dataset.img; }
      if (s) s.scrollTo({ left: 0 });
      if (b.dataset.url) $$('a[data-card-link]', c).forEach((a) => { a.href = b.dataset.url; });
    }));
  });

  /* Countdown */
  $$('[data-bf-count]').forEach((el) => {
    const end = Date.parse(el.dataset.end); if (!end) { el.hidden = true; return; }
    const set = (k, v) => { const n = $(`[data-u=${k}]`, el); if (n) n.textContent = String(v).padStart(2, '0'); };
    const tick = () => { let s = Math.floor((end - Date.now()) / 1000); if (s <= 0) { el.hidden = true; return false; } set('d', Math.floor(s / 86400)); s %= 86400; set('h', Math.floor(s / 3600)); s %= 3600; set('m', Math.floor(s / 60)); set('s', s % 60); return true; };
    if (tick()) { el.hidden = false; const iv = setInterval(() => { if (!tick()) clearInterval(iv); }, 1000); }
  });

  $$('[data-bf-top]').forEach((b) => b.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' })));

  /* Video popup */
  document.addEventListener('click', (e) => {
    const v = e.target.closest('[data-bf-video]'); if (!v) return; e.preventDefault();
    const m = document.createElement('div'); m.className = 'bf-vmodal';
    const src = v.dataset.bfVideo;
    m.innerHTML = /youtu|vimeo/.test(src) ? `<iframe src="${src}" allow="autoplay; fullscreen" allowfullscreen></iframe>` : `<video src="${src}" controls autoplay playsinline></video>`;
    const x = document.createElement('button'); x.type = 'button'; x.setAttribute('aria-label', 'Close video'); x.textContent = '✕';
    x.addEventListener('click', () => m.remove()); m.addEventListener('click', (ev) => { if (ev.target === m) m.remove(); });
    m.appendChild(x); document.body.appendChild(m);
  });

  /* Before / after toggle */
  $$('[data-bf-compare]').forEach((w) => {
    const bs = $$('button', w), parts = $$('[data-part]', w.parentElement);
    const set = (i) => { bs.forEach((x, j) => x.setAttribute('aria-pressed', String(j === i))); parts.forEach((p, j) => p.classList.toggle('is-dim', j !== i)); };
    bs.forEach((b, i) => b.addEventListener('click', () => set(i))); set(bs.length - 1);
  });

  /* Popup */
  const pop = $('#BfPop'), tab = $('#BfPopTab');
  if (pop) {
    const KEY = 'bfPopSeen'; let seen = false; try { seen = sessionStorage.getItem(KEY); } catch (e) {}
    const show = () => { pop.hidden = false; if (tab) tab.hidden = true; };
    const hide = () => { pop.hidden = true; if (tab) tab.hidden = false; try { sessionStorage.setItem(KEY, 1); } catch (e) {} };
    $$('[data-bf-pop-close]', pop).forEach((b) => b.addEventListener('click', hide));
    if (tab) tab.addEventListener('click', show);
    const design = window.Shopify && window.Shopify.designMode;
    if (pop.dataset.posted === 'true') show();
    else if (!seen && !design) setTimeout(() => { try { if (!sessionStorage.getItem(KEY)) show(); } catch (e) { show(); } }, parseInt(pop.dataset.delay || '8', 10) * 1000);
    else if (tab) tab.hidden = false;
  }

  /* Cart */
  const cartIds = () => $$('[data-bf-cart-section]').map((e) => e.dataset.bfCartSection);
  const paint = (sections) => {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      const cur = $(`[data-bf-cart-section="${id}"]`); if (!cur || !html) return;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(`[data-bf-cart-section="${id}"]`);
      if (fresh) { const inner = $('[data-bf-cart-inner]', cur), fi = $('[data-bf-cart-inner]', fresh); if (inner && fi) inner.innerHTML = fi.innerHTML; else cur.innerHTML = fresh.innerHTML; }
    });
    BF.initCarousels(); BF.initCards();
  };
  const count = (n) => $$('[data-bf-count-bubble]').forEach((b) => { b.textContent = n; b.classList.toggle('is-empty', !n); });
  const post = async (url, body) => {
    const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(Object.assign(body, { sections: cartIds().join(','), sections_url: location.pathname })) });
    const d = await r.json(); if (!r.ok || d.status) throw new Error(d.description || d.message || 'Something went wrong');
    return d;
  };
  BF.refreshCount = async () => { try { const c = await (await fetch(R.cart + '.js')).json(); count(c.item_count); return c; } catch (e) { return null; } };
  const drawer = $('#BfCart');
  BF.openCart = () => { if (!drawer) { location.href = R.cart; return; } drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; BF.initCarousels(drawer); };
  BF.closeCart = () => { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; };
  BF.add = async (items, open = true) => { const d = await post(R.cartAdd + '.js', { items }); paint(d.sections); await BF.refreshCount(); if (open) BF.openCart(); return d; };
  BF.change = async (key, quantity) => { const d = await post(R.cartChange + '.js', { id: key, quantity }); paint(d.sections); count(d.item_count); return d; };

  document.addEventListener('click', async (e) => {
    const o = e.target.closest('[data-bf-cart-open]'); if (o && drawer) { e.preventDefault(); BF.openCart(); return; }
    if (e.target.closest('[data-bf-cart-close]')) { BF.closeCart(); return; }
    const q = e.target.closest('[data-bf-qty]');
    if (q) { const line = q.closest('[data-key]'); line.classList.add('is-busy'); const n = Math.max(0, parseInt(line.dataset.qty, 10) + (q.dataset.bfQty === '1' ? 1 : -1)); try { await BF.change(line.dataset.key, n); } catch (err) { BF.toast(err.message); line.classList.remove('is-busy'); } return; }
    const rm = e.target.closest('[data-bf-remove]');
    if (rm) { const line = rm.closest('[data-key]'); line.classList.add('is-busy'); try { await BF.change(line.dataset.key, 0); } catch (err) { BF.toast(err.message); line.classList.remove('is-busy'); } return; }
    const sw = e.target.closest('[data-bf-protect]');
    if (sw) { sw.disabled = true; try { if (sw.getAttribute('aria-pressed') === 'true') await BF.change(sw.dataset.key, 0); else await BF.add([{ id: parseInt(sw.dataset.bfProtect, 10), quantity: 1 }], false); } catch (err) { BF.toast(err.message); } sw.disabled = false; return; }
    const ad = e.target.closest('[data-bf-add]');
    if (ad) {
      e.preventDefault(); const box = ad.closest('[data-bf-add-box]') || ad.parentElement; const sel = $('select[data-bf-variant]', box);
      const id = parseInt(sel ? sel.value : ad.dataset.bfAdd, 10); if (!id) return;
      const inDrawer = !!ad.closest('#BfCart');
      ad.classList.add('is-loading');
      try { await BF.add([{ id, quantity: 1 }], !inDrawer); if (inDrawer) BF.toast('Added to your cart'); } catch (err) { BF.toast(err.message); }
      ad.classList.remove('is-loading');
    }
  });

  const init = () => { BF.initCarousels(); BF.initCards(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();